import React, { Component } from 'react'
import CryptoJS from "crypto-js";
import { API_BASE_URL, SECRET_KEY, emailPattern, TYPE_SUCCESS, INTERVAL, TYPE_FAIL  } from "assets/constants/Constants";
import { USER_ICON } from "assets/constants/Icons"
import ShowToast from 'components/ShowToast';
import axios from "axios";
import md5 from 'md5';
import AuthContext from 'context/AuthProvider';
import config from "../../config.json";

export class ForgotPassword extends Component {
    constructor(props) {
        super(props)
      // console.log("this.props.match.params.clientID: ",this.state.clientID);
        this.state = {
            isLoading: true,
            emailId: "",
            password: "",
            error: {},
            brandLogo: "",
            siteLogoMainImage: "",
            clientID : sessionStorage.getItem("clientID-USER"),
            input: {},
            userName: "",
            clientName: "",
            siteBackGroundImage: "",
            backGroundImageChange: false
        }
    }

    componentDidMount = async () => {
        if (this.context.isAuthenticated()) {
            window.location.href = "/user-page";
        }

        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";

        const clientID = this.state.clientID;

        if (clientID) {
            const siteUrlData = await this.getUrlSite();
            const defaultLogoImage =
            siteUrlData.data.result.client_logoImage_primary;
            const backGroundImage = siteUrlData.data.result.defaultImage_uploadedImage;
            const clientName =  siteUrlData.data.result.client_name;

            const sitelogoImage =
                defaultLogoImage?.base64Data || defaultLogoImage || null;

            const siteBackGroundImage = backGroundImage?.base64Data || backGroundImage || null;

            this.setState({
                backGroundImageChange: true,
                siteLogoMainImage: sitelogoImage,
                siteBackGroundImage: siteBackGroundImage,
                clientName: clientName,
                brandLogo: sitelogoImage || this.context.BRAND_LOGO,
                isLoading: false
            });
        } else {
            this.setState({
                backGroundImageChange: false,
                brandLogo: this.context.BRAND_LOGO,
                isLoading: false
            });
        }
    };


    getUrlSite = async () => {
        return await axios(`${API_BASE_URL}/site/${this.state.clientID}`);
    }
    
    emailIdChangeHandler = (event) => {
        this.setState({
            emailId: event.target.value
        });
    }

    isFormValid = () => {
        let isValid = true;
        let input = this.state.input;
        let error = {};
        
        // if(this.state.emailId){
        //     if (!emailPattern.test(this.state.emailId)) {
        //         isValid = false;
        //         error.emailId = "Please enter valid email address.";
        //     }   
        // }
          if (!input["userName"]) {
            isValid = false;
            error["userName"] = "Please enter your username.";
        }

        this.setState({
            error
        });
        return isValid;
    }

    recoverPasswordHandler = async (event) => {
        event.preventDefault();
        if(this.isFormValid()){
            this.setState({isLoading: true,})
            var buf = new Uint8Array(6);
            window.crypto.getRandomValues(buf);
            let password = window.btoa(String.fromCharCode.apply(null, buf)); 
    
            const requestData = {
                // userEmailId: this.state.emailId,
                userName: this.state.input.userName,
                userPassword:md5(password), 
                displayPass: CryptoJS.AES.encrypt(password, SECRET_KEY).toString(),
            }  
            ShowToast('Please wait while reset password', TYPE_SUCCESS, INTERVAL, this.props, ""); 
            try {
                const userResponse = await axios.post(`${API_BASE_URL}/user/forgetPassword/${this.state.input.userName}/${this.state.userPassword}`, requestData );
            if(userResponse.status === 200){
            ShowToast('Password reset successfully !', TYPE_SUCCESS, INTERVAL, this.props, "/login-page"); 
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    ShowToast('The username you entered is incorrect. Please try again.',TYPE_FAIL,INTERVAL,this.props,"");
                } else {
                    ShowToast('Something went wrong. Please try again later.',TYPE_FAIL,INTERVAL,this.props,"");
                }
            }
        }   
    }

    handleInputChange = (event) => {
        let input = this.state.input;
        input[event.target.name] = event.target.value;
        this.setState({
            input,
        });
    }

    render() {
        const value = this.state.siteBackGroundImage ? this.state.siteBackGroundImage.base64Data ? this.state.siteBackGroundImage.base64Data  : this.state.siteBackGroundImage  : null;
        console.log("value::",value)
        const backgroundImageStyle = value ? {
            backgroundImage: `url(${value === "power plant" ? config.POWER_PLANT : value === "electricity plant" ? config.ELECTRICITY_PLANT : value === "hydro plant" ? config.HYDRO_PLANT : value})`,
            height: '100vh',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        }
            : {
                backgroundImage: `url(${config.BRAND_LOGIN_PAGE_BG})`,
                height: '100vh',
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            };
        return (
              <div className={`outer_login_div ${this.state.backGroundImageChange ? 'customBackgroundStyle' : this.context.styles.outerLoginBg}`} style={{
                    ...(this.state.backGroundImageChange ? backgroundImageStyle : {}),
                    overflow: 'hidden'
                }} >
                        <div className="main_div">
                            <div className="brand_logo_view">
                                <img alt="Brand Logo" className="img-no-padding img-responsive" src={this.state.brandLogo} />
                            </div>
                            <div className="title-client-name">{this.state.clientName}</div>
                            <div className="title-forgot">Forgot Password</div>
                           <form style={{ marginBottom: 10 }} action="!#">
                                <div className="input_box">
                                    <input type="text" name="userName" placeholder="Enter Your Username" onChange={this.handleInputChange} />
                                    <div className="icon"><i className={`${USER_ICON} icon`}></i></div>
                                </div>
                                <div className="text-danger ml-2 error_msg">
                                    {this.state.error.userName}
                                </div>
                                <div  style={{ marginTop: 20, marginBottom: 10 }} className={`input_box ${this.context.styles.brandButton}`}>
                                    <button onClick={this.recoverPasswordHandler}>Recover Password</button>
                                </div>
                            </form>
                            <div className="sbem-login-footer">
                                    <img src="\images\new_brand_logo.png" alt="SBEM" /> © {new Date().getFullYear()} SenSphere By SBEM Pvt Ltd.
                                </div>
                        </div>
            </div>
        )
    }
}


ForgotPassword.contextType = AuthContext;
export default ForgotPassword